import { Table } from "antd";

const Table8 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 1,
            service: 'Nạp tiền',
            fee: 'Miễn phí',
        },
        {
            key: 2,
            stt: 2,
            service: 'Rút tiền',
            fee: 'Miễn phí',
        },
        {
            key: 3,
            stt: 3,
            service: 'Chuyển tiền',
            fee: 'Miễn phí',
        },
        {
            key: 4,
            stt: 4,
            service: 'Thanh toán',
            fee: 'Miễn phí',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 55,
            align: 'center',
        },
        {
            title: 'Dịch vụ',
            dataIndex: 'service',
            key: 'service',
            width: 200,
        },
        {
            title: 'Mức phí/Giao dịch',
            dataIndex: 'fee',
            key: 'fee',
            width: 200,
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 8: BIỂU PHÍ SỬ DỤNG VÍ ĐIỆN TỬ HPAY</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table8;